import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doctorActions, patientActions, ehrActions } from "../core/actions";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CASERECORD } from "../shared/constants";
import { format } from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { helperServices } from "../shared/helper";
import PrintIcon from "@mui/icons-material/Print";
import { openNursePrint } from "./VedamaayuNursePrint";

function VedamaayuNurseNotes(props) {
    const dispatch = useDispatch();
    const noteSubgroup = props.noteSubgroup || "nurse";
    const isReadOnly = Boolean(props.readOnly);
    const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
    const inputRefs = useRef([]);
    const [status, setStatus] = useState(undefined);
    const [todayDate, setTodayDate] = useState(new Date());
    const [revisitDate, setRevisitDate] = useState(
        format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
    );
    const [diagnosistemplate, setDiagnosistemplate] = useState();
    const [followUpdateFlag, setFollowUpdateFlag] = useState(true);
    const [patientDetail, setPatientDetail] = useState({
        patientId: "",
        lastvisitId: "",
        scheduleddate: "",
    });

    const [notes, setNotes] = useState({
        "Comment": "",
        "Follow Up Date For Vedamaayu": "",
        "BP": "",
        "Temperature": "",
        "Pulse": "",
        "Respiratory Rate": "",
        "Saturation": "",
        "Height": "",
        "Weight": "",
        "GRBS": "",
        "Level of Consciousness": "",
        "Respiratory Status": "",
        "Nurse Chief Complaint": "",
        "Skin Integrity": "",
        "Current Medications": "",
        "Investigation Ordered": "",
        "Diet": "",
        "Vulnerable Nurse": "",
        "Special Care": "",
        "Pain Score": "",
        "Pressure Sores": "",
        "Pressure Sores Description": "",
        "Restraints Used": "",
        "Restraint Description": "",
    });

    const [showError, setShowError] = useState(false);
    const [ServerRes, setServerRes] = useState({ success: "", error: "" });
    const [loadsummary, setLoadSummary] = useState(false);
    const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
    const [formErrors, setFormErrors] = useState({ "Comment": "" });
    const [filterdProList, setfilterdProList] = useState();
    const [selectedDoctor, setSelectedDoctor] = useState("");

    const useStyles = makeStyles((theme) => ({
        redAsterisk: { color: "red" },
    }));
    const classes = useStyles();

    useEffect(() => {
        console.log("props data is : ", props);
        let patientId = props.patientData.id;
        let visitId = props.patientData.visit.id;
        dispatch(
            patientActions.getrevisitbyId(patientId, visitId, (resCb) => {
                if (resCb) {
                    console.log("resCb doctor Response:", resCb);
                    patientDetail["scheduleddate"] = resCb.scheduleddate;
                    if (
                        patientDetail["scheduleddate"] !== " " &&
                        patientDetail["scheduleddate"] !== undefined &&
                        patientDetail["scheduleddate"] !== null
                    ) {
                        setRevisitDate(
                            format(new Date(patientDetail["scheduleddate"]), "yyyy-MM-dd")
                        );
                    } else {
                        setRevisitDate(
                            format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
                        );
                    }
                }
            })
        );
        getNotesDetails();
        getDiagnosistemplateById();
    }, []);

    const getNotesDetails = () => {
        props.patientData.patientId = props.patientData.id;
        props.patientData.visitId = props.patientData.visit.id;
        props.patientData.groupname = CASERECORD;
        console.log("details :: ", props.patientData);
        const selectedCaseRecordIds =
            props.selectedProcedure?.caseRecordGroup?.map((item) => String(item.id)) || [];
        dispatch(
            patientActions.getDischargeSummary(notes, props.patientData, (resCb) => {
                if (resCb) {
                    console.log("resCb doctor Response:", resCb);
                    if (resCb.procedureList) {
                        const filterList = resCb.procedureList.filter(
                            (items) =>
                                items.groupname === CASERECORD &&
                                items.subgroup === noteSubgroup &&
                                (
                                    selectedCaseRecordIds.length === 0 ||
                                    selectedCaseRecordIds.includes(String(items.id))
                                )
                        );
                        const keys = Object.keys(notes);
                        var patientNotes = { ...notes };
                        var filteredProList = [];
                        filterList.forEach((item) => {
                            for (let key of keys) {
                                if (item.claSS == key) {
                                    patientNotes[key] = item.notes;
                                    filteredProList.push(item);
                                    setNotes({ ...patientNotes });
                                }
                            }
                            setfilterdProList([...filteredProList]);
                        });
                    }
                    if (resCb && resCb.vaList && resCb.vaList[0]) {
                        console.log("resCb.vaList[0]", resCb.vaList[0].targetid);
                        getDoctorsList(resCb.vaList[0].targetid);
                    }
                }
            })
        );
    };

    const closeServiceModal = (event) => {
        props.onModalClose(event);
    };

    const saveDiagnosisinEHR = (finaldiagnosis) => {
        let templateId = "Diagnosis";
        let patientId = props.patientData.id;
        let visitId = props.patientData.visit.id;
        console.log("Templateiddddd", diagnosistemplate.content[0].data);
        diagnosistemplate.content[0].subject.name = selectedDoctor;
        for (let item of diagnosistemplate.content[0].data.items) {
            let element = item.name.value;
            const time = new Date(
                new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
            ).toISOString();
            switch (element) {
                case "Problem/Diagnosis name": item.value.value = "Diagnosis"; break;
                case "Clinical description": item.value.value = finaldiagnosis.notes; break;
                case "Date/time of onset": item.value.value = time; break;
                case "Date/time of resolution": item.value.value = time; break;
                case "Date/time clinically recognised": item.value.value = time; break;
                default:
            }
        }
        let notesDetails = finaldiagnosis.notes ? finaldiagnosis.notes : "NA";
        let procedure = props.selectedProcedure ?? null;
        dispatch(
            ehrActions.saveComposition(
                diagnosistemplate, patientId, visitId, templateId,
                patientEhrid, notesDetails, procedure,
                (resCb) => {
                    if (resCb) {
                        if (resCb.successMessages) {
                            props.onModalClose({ success: resCb.successMessages[0] });
                        } else {
                            if (resCb.errorMessages[0]) {
                                props.onModalClose({ error: resCb.errorMessages[0] });
                            }
                        }
                    }
                }
            )
        );
    };

    const getDiagnosistemplateById = () => {
        let templateId = "Diagnosis";
        dispatch(
            ehrActions.getTemplateById("", templateId, {}, (resCb) => {
                if (resCb) {
                    console.log("Getdiagnosiss rescb", resCb);
                    setDiagnosistemplate(resCb);
                }
            })
        );
        return diagnosistemplate;
    };

    const handleInputChange = (name, value) => {
        if (isReadOnly) return;
        setShowError(false);
        console.log("In handleinput change", name, value);
        let updatedFormErrors = { ...formErrors };
        if (name === "Comment" && value.length > 800) {
            updatedFormErrors[name] = name + " exceeds limit of 800 characters";
        } else {
            updatedFormErrors[name] = "";
        }
        setFormErrors(updatedFormErrors);
        formErrors[name] = "";
        var patientNotes = notes;
        var keyList = [];
        patientNotes[name] = value;

        if (filterdProList && filterdProList.length > 0) {
            filterdProList.forEach((item) => {
                if (item.claSS == name) {
                    keyList.push({
                        claSS: item.claSS,
                        notes: value,
                        id: item.id,
                        patientId: item.patientId,
                        visitId: item.visitId,
                    });
                }
                setfilterdProList([...keyList]);
            });
        }
        setNotes({ ...patientNotes });
    };

    const handleSubmit = (e) => {
        validateForm(e);
        setTimeout(() => { console.log("props:", props); }, 3000);
    };

    const setMessageStrip = (e) => {
        console.log("message obtained", e);
        var ServerResVal = ServerRes;
        if (e.success) { ServerResVal.success = e.success; }
        else { ServerResVal.error = e.error; }
        setServerRes({ ...ServerResVal });
        setTimeout(() => { closeAlert(); }, 5000);
    };

    const UpdateRevisitDetails = () => {
        console.log(" insert  props", props);
        patientDetail.patientId = props.patientData.id;
        patientDetail.lastvisitId = props.patientData.visit.id;
        console.log("patientdetail.....", patientDetail, revisitDate);
        let date = format(new Date(revisitDate), "dd-MM-yyyy");
        notes["Follow Up Date For Vedamaayu"] = date;
        patientDetail.scheduleddate = date;
        setFollowUpdateFlag(date);
        console.log("notes adte:", notes["Follow Up Date For Vedamaayu"]);
        return patientDetail;
    };

    const closeAlert = (e) => {
        setServerRes({ ..."" });
    };

    const validateForm = (e) => {
        if (isReadOnly) {
            e.preventDefault();
            return;
        }
        console.log("Submit Notes:", e);
        console.log("formErrors : ", formErrors);
        for (let key in formErrors) {
            if (formErrors[key] !== "") {
                setMessageStrip({ error: "Please check there is a validation error in the notes form" });
                return;
            }
        }
        setShowError(false);
        var ServerResVal = ServerRes;
        e.preventDefault();
        var proList = [];
        let finaldiagnosis = {};
        const followUpDetails = UpdateRevisitDetails();
        const keys = Object.keys(notes);

        if (filterdProList && filterdProList.length > 0) {
            filterdProList.forEach((item) => {
                if (item.claSS === "Follow Up Date For Vedamaayu") {
                    proList.push({ id: item.id, claSS: item.claSS, notes: followUpDetails.scheduleddate, patientId: item.patientId, visitId: item.visitId, subgroup: "nurse" });
                } else {
                    proList.push({ id: item.id, claSS: item.claSS, notes: item.notes, patientId: item.patientId, visitId: item.visitId, subgroup: "nurse" });
                }
            });
            console.log("proList in edit case: ", proList);
        } else {
            for (let key of keys) {
                proList.push({ claSS: key, notes: notes[key], patientId: props.patientData.id, visitId: props.patientData.visit.id, subgroup: "nurse" });
            }
        }
        notes["notes"] = "NOTE";

        dispatch(
            doctorActions.addCaseRecord(proList, (resCb) => {
                if (resCb) {
                    console.log("resCb doctor Response:", resCb);
                    if (resCb.successMessages) {
                        if (finaldiagnosis && finaldiagnosis.notes !== "" && finaldiagnosis.notes !== undefined) {
                            saveDiagnosisinEHR(finaldiagnosis);
                        }
                        props.onModalClose({ success: "Notes added successfully" });
                    } else {
                        props.onModalClose({ error: "Failed to add notes" });
                    }
                    console.log("resCbe : ", resCb);
                }
            })
        );
        setMessageStrip({ success: e.successMessages });
        setServerRes({ ...ServerResVal });
        setTimeout(() => { closeAlert(); }, 3000);
    };

    const ChangeRevisitDate = (event) => {
        console.log("date: ", event.target.value);
        setRevisitDate(event.target.value);
    };

    const getDoctorsList = (targetid, data) => {
        dispatch(
            doctorActions.getDoctorList(data, (resCb) => {
                if (resCb) {
                    for (let doc of resCb) {
                        if (doc != null) {
                            if (!doc.first_name) doc.first_name = "";
                            if (!doc.last_name) doc.last_name = "";
                            const name = helperServices.getFullName(doc.first_name, null, doc.last_name);
                            if (targetid && targetid == doc.personId) {
                                setSelectedDoctor(doc.displaytitle + ". " + name);
                            }
                        }
                    }
                }
            })
        );
    };

    return (
        <>
            {ServerRes.error && (
                <Alert severity="error" className="alert-div">
                    {ServerRes.error}{" "}
                    <IconButton aria-label="close" color="inherit" size="small" onClick={(e) => closeAlert(e)}>
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                </Alert>
            )}

            <div className="bg-none nav-wrapper h-100 d-flex flex-column service-view">
                <div className='"d-flex'>
                    <IconButton
                        aria-label="close"
                        onClick={(event) => closeServiceModal(event)}
                        sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>

                <div className="w-100 service-container service-container1" style={{ overflowY: "auto" }}>
                    <div className="d-flex m-3 justify-content-between px-4">
                        <div className="w-100 flex-wrap flex-column">

                            {showError && (
                                <div className="text-danger my-4">All fields can not be empty!</div>
                            )}



                            <fieldset disabled={isReadOnly} style={{ border: 0, padding: 0, margin: 0 }}>
                            <Box className="row service-form mb-4">

                                <div className="col-12 mb-1"><small><strong>Vitals</strong></small></div>

                                {[
                                    ["BP", "BP"], ["Temperature", "Temperature"], ["Pulse", "Pulse"],
                                    ["Respiratory Rate", "Respiratory Rate"], ["Saturation", "Saturation (if required)"],
                                    ["Height", "Height"], ["Weight", "Weight"], ["GRBS", "GRBS"],
                                ].map(([key, label]) => (
                                    <div key={key} id="notespadding" className="pl-0 col-lg-3 col-xl-3 col-md-3 col-6 pt-2">
                                        <TextField fullWidth className="p-2" value={notes[key]}
                                            placeholder={label} autoComplete="off"
                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                            label={label} />
                                    </div>
                                ))}

                                <div className="col-12 mt-3 mb-1"><small><strong>Examination</strong></small></div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Level of Consciousness"]}
                                        placeholder="Level of Consciousness..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Level of Consciousness", e.target.value)}
                                        label="Level of Consciousness" multiline minRows={1} maxRows={4} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Respiratory Status"]}
                                        placeholder="Respiratory Status..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Respiratory Status", e.target.value)}
                                        label="Respiratory Status" multiline minRows={1} maxRows={4} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Nurse Chief Complaint"]}
                                        placeholder="Present Chief Complaint..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Nurse Chief Complaint", e.target.value)}
                                        label="Present Chief Complaint" multiline minRows={1} maxRows={4} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Skin Integrity"]}
                                        placeholder="Skin Integrity..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Skin Integrity", e.target.value)}
                                        label="Skin Integrity" multiline minRows={1} maxRows={4} />
                                </div>

                                <div className="col-12 mt-3 mb-1"><small><strong>Clinical Details</strong></small></div>

                                <div id="notespadding" className="pl-0 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Current Medications"]}
                                        placeholder="Current Medications..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Current Medications", e.target.value)}
                                        label="Current Medications" multiline minRows={2} maxRows={6} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Investigation Ordered"]}
                                        placeholder="Investigation Ordered..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Investigation Ordered", e.target.value)}
                                        label="Investigation Ordered" multiline minRows={1} maxRows={4} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Diet"]}
                                        placeholder="Diet..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Diet", e.target.value)}
                                        label="Diet" multiline minRows={1} maxRows={4} />
                                </div>

                                <div className="col-12 mt-3 mb-1"><small><strong>Special Care</strong></small></div>

                                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                                    <label className="service-lable mb-1">Vulnerable</label>
                                    <select className="form-control filterin Quantity"
                                        value={notes["Vulnerable Nurse"]}
                                        onChange={(e) => handleInputChange("Vulnerable Nurse", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Special Care"]}
                                        placeholder="Any special care given..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Special Care", e.target.value)}
                                        label="Any Special Care Given" multiline minRows={1} maxRows={4} />
                                </div>

                                <div className="col-12 mt-3 mb-1"><small><strong>Pain Scale</strong></small></div>
                                <div className="col-12 pt-2 mb-2">
                                    <label className="service-lable mb-2 d-block">
                                        Pain Score &nbsp;
                                        <span style={{ fontWeight: "normal", fontSize: "12px", color: "#666" }}>
                                            (0 = No pain &nbsp; 5 = Moderate &nbsp; 10 = Worst pain)
                                        </span>
                                    </label>
                                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                        {[...Array(11).keys()].map((n) => (
                                            <button
                                                key={n} type="button"
                                                onClick={() => handleInputChange("Pain Score", String(n))}
                                                style={{
                                                    width: "36px", height: "36px", border: "1px solid #bbb",
                                                    borderRadius: "4px", cursor: "pointer",
                                                    fontWeight: notes["Pain Score"] === String(n) ? "bold" : "normal",
                                                    background: notes["Pain Score"] === String(n) ? "#1a73e8" : "#fff",
                                                    color: notes["Pain Score"] === String(n) ? "#fff" : "#333",
                                                }}
                                            >{n}</button>
                                        ))}
                                    </div>
                                </div>

                                <div className="col-12 mt-3 mb-1"><small><strong>Pressure Sores & Restraints</strong></small></div>

                                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                                    <label className="service-lable mb-1">Pressure Sores</label>
                                    <select className="form-control filterin Quantity"
                                        value={notes["Pressure Sores"]}
                                        onChange={(e) => handleInputChange("Pressure Sores", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>

                                {notes["Pressure Sores"] === "Yes" && (
                                    <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                                        <TextField fullWidth className="p-2" value={notes["Pressure Sores Description"]}
                                            placeholder="Site, size, description..." autoComplete="off"
                                            onChange={(e) => handleInputChange("Pressure Sores Description", e.target.value)}
                                            label="Description (site, size, etc.)" multiline minRows={1} maxRows={4} />
                                    </div>
                                )}

                                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                                    <label className="service-lable mb-1">Restraints Used</label>
                                    <select className="form-control filterin Quantity"
                                        value={notes["Restraints Used"]}
                                        onChange={(e) => handleInputChange("Restraints Used", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>

                                {notes["Restraints Used"] === "Yes" && (
                                    <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                                        <TextField fullWidth className="p-2" value={notes["Restraint Description"]}
                                            placeholder="Restraint used..." autoComplete="off"
                                            onChange={(e) => handleInputChange("Restraint Description", e.target.value)}
                                            label="Restraint Description" multiline minRows={1} maxRows={4} />
                                    </div>
                                )}

                            </Box>
                            </fieldset>

                            <div className="d-flex align-items-center gap-2 my-4">
                                {!isReadOnly && (
                                    <Button
                                        id="we" type="submit" color="primary" variant="contained"
                                        sx={{ textTransform: "capitalize" }}
                                        className="btn-primary"
                                        onClick={(event) => handleSubmit(event)}
                                    >
                                        Save
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<PrintIcon />}
                                    sx={{ textTransform: "capitalize" }}
                                    onClick={() => {
                                        openNursePrint(notes, props.patientData);
                                    }}
                                >
                                    Print
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VedamaayuNurseNotes;
